import React, { useContext } from "react";
import profileIconW from "../assets/images/interface/person-circle-outline-white.svg";
import HomeMobile from "../components/headers/HomeMobile";


const MobileLayout = (props) => {
  const { content } = props;
  return (
    <div className="home-background-image">
      <div className="home-background-color">
        <img
          className="home-profileWhite desktop-noDisplay"
          src={profileIconW}
          alt="profile"
        ></img>

        <div className={'home-container home-mobile'}>
          <HomeMobile />

          <div className="home-column home-column-right home-mobile">
            {content}

          </div>
          <div className="home-politica home-mobile">Política de Privacidad</div>

        </div>
      </div>
    </div>

  );
}

export default MobileLayout;
